module.exports = __webpack_public_path__ + "img/desiccant-settings.075c1b16.jpg";